export default {"src":"/_next/static/media/tick-with-grey-circle.9e5f18aa.svg","height":80,"width":80};